export default __webpack_public_path__ + "static/media/02.4fe7f6de.jpg";